// extracted by mini-css-extract-plugin
module.exports = {"offcanvas-bottom":"offcanvas_offcanvas-bottom__3HkcR","offcanvas-body":"offcanvas_offcanvas-body__TQb-Z"};